import { Mail, FileText, BarChart } from "lucide-react";

export const ICON_MAP = { "Email Template": Mail, Presentation: FileText, "Case Study": BarChart, "Battle Card": FileText };
export const CATEGORIES = ["all", "Email Template", "Presentation", "Case Study", "Battle Card"];

export const categoryTestId = (c) => `category-${c.toLowerCase().replace(/\s+/g, "-")}`;

export const filterContent = (items, query, category) => {
  const q = query.trim().toLowerCase();
  return items.filter((item) => {
    const matchesSearch = !q || item.title?.toLowerCase().includes(q) || item.description?.toLowerCase().includes(q) || item.tags?.some((t) => t.toLowerCase().includes(q));
    const matchesCategory = category === "all" || item.type === category;
    return matchesSearch && matchesCategory;
  });
};

export const FADE_UP = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } };
